/**
 * Use this as the Nexus tenant token when Nexus logging is not needed or relevant
 */
export const SuppressNexus = -1;

/* Contracts in a big object, for backwards compatibility */
export * from './contracts/Contracts';

/* Contracts in individual objects, for size optimization */
export * from './Contracts';

export * from './DataModels';
export { IActivityScope } from './Activity';
export * from './DataFieldHelper';
export * from './EventFlagFiller';
export * from './OTelNotifications';
export * from './SimpleTelemetryLogger';
export * from './TelemetryLogger';

/* Enums for callers who don't like const enums */
export * from './enumObjects/EnumObjects';
